import { css } from '@emotion/react'
import mediaQueries from './media-queries'

const categoryStyles = {
  category: (theme) => css`
    position: relative;
    margin-top: 30px;

    ${mediaQueries.smallScreen()} {
      padding-right: 32px;
      padding-left: 32px;
    }

    ${mediaQueries.mediumScreen()} {
      padding-left: 0;
    }

    ${mediaQueries.xlargeScreen()} {
      padding-right: 60px;
    }

    .content {
      display: flex;

      .body {
        width: 100%;

        @media (min-width: ${mediaQueries.MEDIUM}) and (max-width: ${mediaQueries.X_LARGE}) {
          max-width: 60vw;
        }

        @media (min-width: ${mediaQueries.X_LARGE}) {
          max-width: 960px;
        }

        .name {
          display: flex;
          flex-direction: column;
          max-height: 54px;
          overflow: hidden;
          margin-bottom: 24px;

          .title {
            color: ${theme.colors.black950};
            margin: 0;

            font-weight: ${theme.font.bold};
            font-size: 22px;
            line-height: 26px;

            ${mediaQueries.smallScreen()} {
              font-size: 24px;
              line-height: 29px;
            }
          }

          .subtitle {
            color: ${theme.colors.black500};
            font-size: 13px;
            line-height: 16px;
            letter-spacing: 0.005em;
            margin-top: 11px;
          }
        }

        .with-margin {
          margin-bottom: 24px;
        }

        .campaign-apps {
          margin: 100px 0;
        }

        .secondary-apps {
          margin-top: 100px;
        }
      }
    }
  `,
  featuredCategories: (isOddItemsCount) => css`
    margin-bottom: 30px;

    ${mediaQueries.smallScreen()} {
      margin-bottom: 0;
    }

    @media (min-width: ${mediaQueries.SMALL}) and (max-width: ${mediaQueries.BASE_LARGE_SIZE -
      1}px) {
      > div:last-of-type > div:last-of-type {
        ${isOddItemsCount && `display: none;`}
      }
    }
  `,
}

export default categoryStyles
